export const mobileNumberValidation = (inputValue) => {
  const limit = 10;
  return inputValue.slice(0, limit);
}
export const fileNameValidation = (fileName) => {
  const fileNameCharNotAllowed = /["$%*/\:?<>|]/
  if (fileNameCharNotAllowed.test(fileName)) {
    return true
  } else {
    return false
  }
}
export const capitalizeFunction = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
export const emailValidation = (email) => {
  return /\S+@\S+\.\S+/.test(email);
}
export const nameValidation = (name) => {
  /*    return VALIDATION.ToTitleCase(name).replace(/[^a-z]/gi, '');*/
  return name.replace(/[^a-z]/gi, '');
}
export const isValidName = (name) => {
  return /^[a-z ,.'-]+$/i.test(name);
}
export const pincodeValidation = (inputValue) => {
  const limit = 6;
  return inputValue.slice(0, limit);
}
export const typeNumberValid = (evt) => {
  return (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+' || evt.key === 'Enter') && evt.preventDefault()
}
export const plotValidationForKatha = (value) => {
  const kathaLimit = 6
  const valueLimited = value.replace(/[^0-9]/g, '').replace(/^0+/, '')
  return valueLimited.slice(0, kathaLimit)
}
export const plotValidationForOtherUnits = (value) => {
  const restLimit = 6
  const valueLimited = value.replace(/[^0-9]/g, '').replace(/^0+/, '')
  return valueLimited.slice(0, restLimit)
}
export const totalNumberOfClumpValidation = (value) => {
  const limit = 6;
  const valueLimited = value.replace(/[^0-9]/g, '')
  return valueLimited.slice(0, limit)
}
export const plantationValidation = (value) => {
  const limit = 20;
  const valueLimited = value.replace(/[^0-9]/g, '').replace(/^0+/, '')
  return valueLimited.slice(0, limit)
}
export const typeDecimalValid = (evt) => {
  return (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()
}
export const landAreaValidation = (value) => {
  const limit = 6;
  const valueLimited = value.replace(/[^0-9]/g, '')
  return valueLimited[0] == 0 ? valueLimited.slice(0, 1) : valueLimited.slice(0, limit)
}
export const maxNameLength = 100
export const emailUrnPassMaxLength = 50
export const otpMaxLength = 6
export const openTextFieldMaxLength = 500
export const backgroundMaxLength = 4000
export const justificationMaxLength = 4000
export const approverCommentMaxLength = 300
export const resourceMaxLength = 50
export const shortListWaitlistMaxcount = 30
export const addressMaxLength = 300
export const mobileNoMaxLength = 10
export const totalPlotsMaxLength = 6
export const totalClumpsMaxLength = 6
export const pincodeMaxLength = 6
export const govtIDcardLength = 20
export const bankAccountNumber = 40
export const linkMaxLength = 100
export const lastFourDigit = 4
export const urnMaxLength = 12
export const maxWeightLength = 10

export const recordedValueLimit = (inputValue) => {
  const limit = 5;
  return inputValue.slice(0, limit);
}

export const accountNumberLimit = (inputValue) => {
  const limit = 20;
  return inputValue.slice(0, limit);
}

export const checkDateValidation = (startDate, endDate) => {
  if ((new Date(startDate) > new Date(endDate)) || (new Date(endDate) < new Date(startDate))) {
    return true;
  } else {
    return false;
  }
}
export const VALIDATION = {
  gstNumberValidation: (value) => {
    return /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(value);
  },
  panNumberValidation: (value) => {
    return /[A-Z]{5}\d{4}[A-Z]{1}$/.test(value);
  },
  ifscValidation: (value) => {
    return /[A-Z]{4}0[A-Z0-9]{6}$/.test(value);
  },
  latitudeLongitudeValidation: (value) => {
    return /^(\d{2})([.]{1})(\d{5,15})$/.test(value);
  },
  bankAccountNumberValidation: (value) => {
    return /^(\d{5})(\d{1,13})$/.test(value);
  },
  bankAccountNameValidation: (value) => {

    return value.replace(/[^A-Za-z0-9. ]/gi, '');
  },
  fullNameValidation: (value) => {
    /*return VALIDATION.ToTitleCase(value).replace(/[^A-Za-z. ]/gi, '');*/
    return value.replace(/[^A-Za-z0-9. ]/gi, '');
  },
  noSpecialCharacterValidation: (value) => {
    return value.replace(/[^a-z0-9!~@#&*()_+?,.%:\n ]/gi, '');
  },
  noSpecialCharCapsValidation: (value) => {
    return value.replace(/[^a-z0-9!~@#&*()_+?,.%:\n ]/gi, '');
  },
  endDateValidation: (currentDate, endDate) => {
    if ((new Date(currentDate) > new Date(endDate)) || (new Date(endDate) < new Date(currentDate))) {
      return true;
    } else {
      return false;
    }
  },
  weightsSlicedValue: (value) => {
    const restLimit = 5
    const valueLimited = value.replace(/[^0-9]/g, '').replace(/^0+/, '')
    return valueLimited.slice(0, restLimit)
  },
  weightsValidation: (vehicleType, weightValue) => {
    const conversionFactorToKg = 1000
    const minMaxValueArr = [
      {
        vehicleType: "LCV",
        minValue: 3.5 * conversionFactorToKg,
        maxValue: 7.5 * conversionFactorToKg
      },
      {
        vehicleType: "MCV",
        minValue: 7.5 * conversionFactorToKg,
        maxValue: 18.5 * conversionFactorToKg
      },
      {
        vehicleType: "HCV",
        minValue: 18.5 * conversionFactorToKg,
        maxValue: 49 * conversionFactorToKg
      },
    ]
    const minmaxValeObject = minMaxValueArr.find((item) => item.vehicleType === vehicleType)
    if (weightValue < minmaxValeObject?.minValue || weightValue > minmaxValeObject?.maxValue) {
      return `Weight of the ${vehicleType} vehicle should be between ${minmaxValeObject.minValue}kgs and ${minmaxValeObject.maxValue}kgs i.e ${minmaxValeObject.minValue / conversionFactorToKg}MT - ${minmaxValeObject.maxValue / conversionFactorToKg}MT`
    }
    else return ''
  },
  registrationNumberValidation: (value) => {
    let NUMBERPLATE = value.toUpperCase();
    let regex = new RegExp(/^[A-Z]{2}[0-9]{2}([A-Z]{1,2}[0-9]{4}|[0-9]{4})$/);

    if (NUMBERPLATE == null) {
      return false;
    }

    return regex.test(NUMBERPLATE);
  },

  ToTitleCase: (input) => {
    input = input.toLowerCase();
    const arr = input.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    var output = arr.join(" ");
    return output;
  },
  ToSentenceCase: (input) => {
    input = input.toLowerCase();
    const arr = input.split(".");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    var output = arr.join(".");
    const arr2 = output.split("\n");
    for (var i = 0; i < arr2.length; i++) {
      arr2[i] = arr2[i].charAt(0).toUpperCase() + arr2[i].slice(1);
    }
    var output2 = arr2.join("\n");
    return output2;
  }
}

export const openTextFieldValidation = (input) => {
  return input.replace(/[^\w\s.,]/gi, ''); // Allow letters, digits, spaces, dot, and comma
};

export const weightValidation = (value) => {
  const regex = /^\d{0,8}(\.\d{0,4})?$/;
  return regex.test(value)
}

export const validateAmount = (inputAmount) => {
  const regex = /^(?!0\d)\d{0,9}(\.\d{0,2})?$/;
  if (regex.test(inputAmount)) {
    const parsedAmount = parseFloat(inputAmount);
    if (!isNaN(parsedAmount) && parsedAmount <= 1000000000) {
      return parsedAmount;
    }
  }
  return null;
};

export const PIT_VALIDATIONS = {
  validation: (value) => {
    const regex = /^\d{0,15}(\.\d{0,2})?$/;
    return regex.test(value);
  },
  dataGridValidation: (value, integerPartLimit, decimalPartLimit) => {
    const valueAsString = String(value);
    const [integerPart, decimalPart] = valueAsString.split(".");
    const hasErrorInteger = integerPart.length > integerPartLimit;
    const hasErrorDecimal = (decimalPart && decimalPart.length > decimalPartLimit);
    const hasError = hasErrorInteger || hasErrorDecimal;
    return hasError ? "Invalid number format. Max 10 digits before the decimal and 4 digits after." : null
  },
qtyValidation: (value, scheduledQty, integerPartLimit, decimalPartLimit) => {
    if (value === null || value === undefined || value === '') return null;
    
    const valueAsString = String(value);

    const isValidNumericFormat = /^\d*\.?\d*$/.test(valueAsString);
    if (!isValidNumericFormat) {
        return "Invalid entry. Only numbers and a single decimal point are allowed.";
    }
    
    const numValue = Number(value);
    const numScheduled = Number(scheduledQty);
    
    const hasError = numValue < numScheduled;
    const hasZeroError = numValue < 0;
    
    const [integerPart, decimalPart] = valueAsString.split(".");
    
    // 4. Safely check lengths
    const hasErrorInteger = integerPart && integerPart.length > integerPartLimit;
    const hasErrorDecimal = decimalPart && decimalPart.length > decimalPartLimit;
    const hasMaxLimitError = hasErrorInteger || hasErrorDecimal;

    return hasError ? `Modified Quantity should not be less than Received Quantity` 
         : hasZeroError ? `Modified Quantity can not be less than 0` 
         : hasMaxLimitError ? `Invalid number format. Max ${integerPartLimit} digits before the decimal and ${decimalPartLimit} digits after.` 
         : null;
},

  commentValidation: (value, limit) => {
    const valueAsString = String(value);
    const hasError = valueAsString.length > limit;
    // const hasEmptyError = valueAsString.length === 0
    // return hasError ? "Enter withing 200 characters!" : hasEmptyError ? 'Please Enter Comment' : null
    return hasError ? "Enter withing 200 characters!" : null
  }
}

export const DEMAND_VALIDATIONS = {
  annualCBValidation: (value) => {
    const regex = /^\d{0,10}(\.\d{0,2})?$/;
    return regex.test(value);
  },
  rbcbRatioValidation: (value) => {
    const regex = /^\d{0,1}(\.\d{0,2})?$/;
    return regex.test(value);
  },
  commonValidation: (value) => {
    const regex = /^\d{0,8}(\.\d{0,2})?$/;
    return regex.test(value);
  },
  dataGridValidation: (value, integerPartLimit, decimalPartLimit) => {
    const valueAsString = String(value);
    const [integerPart, decimalPart] = valueAsString.split(".");
    const hasErrorInteger = integerPart.length > integerPartLimit;
    const hasErrorDecimal = (decimalPart && decimalPart.length > decimalPartLimit);
    const hasError = hasErrorInteger || hasErrorDecimal;
    return hasError ? "Invalid number format. Max 8 digits before the decimal and 2 digits after." : null
  },
  paymentValidation: (value, integerPartLimit, decimalPartLimit) => {
    const valueAsString = String(value);
    const [integerPart, decimalPart] = valueAsString.split(".");
    const hasErrorInteger = integerPart.length > integerPartLimit;
    const hasErrorDecimal = (decimalPart && decimalPart.length > decimalPartLimit);
    const hasError = hasErrorInteger || hasErrorDecimal || value > 100;
    return hasError ? "Max value is 100 and only 2 digits are allowed after decimal" : null
  },
}

export const VehicleValidation = (value, integerPartLimit, decimalPartLimit) => {
  const valueAsString = String(value);
  const [integerPart, decimalPart] = valueAsString.split(".");
  const hasErrorInteger = integerPart.length > integerPartLimit;
  const hasErrorDecimal = (decimalPart && decimalPart.length > decimalPartLimit);
  const hasError = hasErrorInteger || hasErrorDecimal;
  return hasError ? "Only 5 digits are allowed and only 2 digi are allowed after decimal" : null
}
